import ChoroplethChartWidget from './choropleth-chart.widget';
import { choroplethWidgetSettings } from './widget-settings';
export default ChoroplethChartWidget;
export { choroplethWidgetSettings };
